// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const getCachedData = <T extends any>(key: string) => {
  const app = useNuxtApp()
  return (app.static.data[key] as T | undefined) ?? (app.payload.data[key] as T | undefined)
}

const cacheTimestamps = new Map<string, number>()

/**
 * Factory that returns a getCachedData function with TTL expiration.
 * Returns cached data if within TTL, otherwise returns undefined to trigger a refetch.
 * TTL is only enforced on the client — SSR always returns cached data.
 */
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const getCachedDataWithTTL = <T extends any>(ttl: number) => {
  return (key: string): T | undefined => {
    const app = useNuxtApp()
    const cached = (app.static.data[key] as T | undefined) ?? (app.payload.data[key] as T | undefined)

    if (!cached)
      return undefined
    if (!import.meta.client)
      return cached

    const fetchedAt = cacheTimestamps.get(key)
    if (!fetchedAt) {
      cacheTimestamps.set(key, Date.now())
      return cached
    }

    if (Date.now() - fetchedAt > ttl) {
      cacheTimestamps.delete(key)
      return undefined
    }

    return cached
  }
}
